import React, { useContext } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../helpers";
import { DrugAutocomplete } from "../../components";
import { AppContext } from "../../app/store";
import { sendDrugConfirmationTealiumEvent } from "../../helpers/prescriptionHelpers";
import { AutocompleteDrug, AutocompletePapDrug } from "../../@types";
import {
  AnalyticsActionType,
  AnalyticsButtonStyle,
  AnalyticsButtonType,
} from "../../app/contexts/Analytics/types";

interface AddPrescriptionProps {
  isFromSummaryPage?: boolean;
  onSelectDrug: (addedDrug: {
    is_generic: boolean;
    rxcui: string;
    name: string;
    insulin: boolean;
  }) => void;
  goToPlans: () => void;
  goToPharmacySelection: () => void;
  goToViewPrescriptions: () => void;
}

const AddPrescription: React.FunctionComponent<AddPrescriptionProps> = ({
  isFromSummaryPage = false,
  onSelectDrug,
  goToPlans,
  goToPharmacySelection,
  goToViewPrescriptions,
}) => {
  const t = useTranslate();
  const { state, dispatch } = useContext(AppContext);
  const { prescriptions, mbpReferrerUri } = state;

  const addDrug = (
    selectedDrug: AutocompleteDrug | AutocompletePapDrug
  ): void => {
    onSelectDrug(selectedDrug as AutocompleteDrug);
  };

  return (
    <div className="AddPrescription">
      <DrugAutocomplete
        onSelectDrug={addDrug}
        submitButtonText={t("drug_search.add_drug")}
      />

      <div className="AddPrescription__actions">
        <Button
          variation="solid"
          onClick={(): void => {
            dispatch({
              type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
              settings: {
                button: {
                  buttonStyle: AnalyticsButtonStyle.DEFAULT,
                  buttonType: AnalyticsButtonType.BUTTON,
                  text: t("prescription.button.done_adding_drugs"),
                },
              },
            });
            sendDrugConfirmationTealiumEvent(prescriptions, dispatch);
            if (mbpReferrerUri !== "" || isFromSummaryPage) {
              // standalone drugs, go back to my saved drugs
              goToViewPrescriptions();
            } else {
              goToPharmacySelection();
            }
          }}
          className="e2e-drug-next ds-u-margin-right--0 ds-u-md-margin-right--2 mct-u-width--full mct-u-md-width--auto"
        >
          {t("prescription.button.done_adding_drugs")}
        </Button>
        {prescriptions.length === 0 && (
          <Button
            data-testid="continue-to-plans"
            className="mct-u-width--full mct-u-md-width--auto ds-u-margin-top--2 ds-u-md-margin-top--0"
            onClick={(): void => {
              dispatch({
                type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
                settings: {
                  button: {
                    buttonStyle: AnalyticsButtonStyle.DEFAULT,
                    buttonType: AnalyticsButtonType.BUTTON,
                    text: t("drug_search.continue_to_plans"),
                  },
                },
              });
              dispatch({
                type: AnalyticsActionType.SEND_TEALIUM_EVENT,
                settings: {
                  event_action: "Find Plans - Add Drugs",
                  event_label: "Continue to Plans",
                },
              });
              goToPlans();
            }}
          >
            {t("drug_search.continue_to_plans")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default AddPrescription;
